<template>
    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body py-4 px-md-5">
            <div class="profile-container d-flex mb-4">
              <b-skeleton type="avatar" width="250px" height="250px"></b-skeleton>
              <div
                class="p-md-3 mx-md-3 d-flex flex-column justify-content-center"
              >
                <b-skeleton width="150px" height="2em"></b-skeleton>
                <b-skeleton width="200px" height="1.25em"></b-skeleton>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 px-md-3">
          <h3>User Info</h3>
          <div class="row" style="background: none">
            <div class="col-md-4">
              <div class="card p-3">
                <b-skeleton class="mb-1" width="50%" height="1.25em"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card p-3">
                <b-skeleton class="mb-1" width="50%" height="1.25em"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card p-3">
                <b-skeleton class="mb-1" width="50%" height="1.25em"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="card p-3">
                <b-skeleton class="mb-1" width="50%" height="1.25em"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
export default {
    name: "ProfileSkeleton"
}
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .profile-container {
    padding-top: 2rem;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
.profile-image {
  --image-size: 250px;
  width: var(--image-size);
  height: var(--image-size);
  border-radius: 100vh;
}
.change-password {
  position: absolute !important;
  top: 0;
  right: 0;
}
.btn-menu:hover {
  background-color: #f0f0f0;
}
.dropdown-item:focus,
.dropdown-item:hover {
  background-color: #f0f0f0 !important;
}
</style>